// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .white .mat-form-field-wrapper {
  padding-bottom: 0;
}

@media only screen and (max-width: 599px) {
  .mat-form-field {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/dropdown/dropdown.component.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;AAAJ;;AAIA;EACE;IACE,WAAA;EADF;AACF","sourcesContent":["::ng-deep {\n  .white .mat-form-field-wrapper{\n    padding-bottom: 0;\n  }\n}\n\n@media only screen and (max-width: 599px) {\n  .mat-form-field{\n    width:100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
